import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
	changeDetection: ChangeDetectionStrategy.OnPush,
	selector: 'bp-icon-star',
	templateUrl: './icon-star.component.svg',
})
export class IconStarComponent {}
